import { taskAxiosInstance } from "../axiosInstance";
import type { TaskOccurrenceStatus } from "./types";

export interface TaskOccurrence {
    id: number;
    globalId: string;
    taskId: number;
    scheduledAt: string;
    startedAt: string | null;
    finishedAt: string | null;
    status: TaskOccurrenceStatus;
    createdAt: string;
}

export interface TaskOccurrenceQuery {
    instanceId?: number;
    taskId?: number;
    status?: TaskOccurrenceStatus;
    scheduledFrom?: string | Date;
    scheduledTo?: string | Date;
    skip?: number;
    take?: number;
}

export interface TaskOccurrenceListResponse {
    data: TaskOccurrence[];
    total: number;
}

const toDateParam = (value?: string | Date) => {
    if (!value) return undefined;
    return value instanceof Date ? value.toISOString() : value;
};

export const getTaskOccurrences = async (
    query: TaskOccurrenceQuery = {},
): Promise<TaskOccurrenceListResponse> => {
    const params = new URLSearchParams();
    if (query.instanceId !== undefined) params.set("instanceId", query.instanceId.toString());
    if (query.taskId !== undefined) params.set("taskId", query.taskId.toString());
    if (query.status) params.set("status", query.status);

    const scheduledFrom = toDateParam(query.scheduledFrom);
    const scheduledTo = toDateParam(query.scheduledTo);
    if (scheduledFrom) params.set("scheduledFrom", scheduledFrom);
    if (scheduledTo) params.set("scheduledTo", scheduledTo);

    if (query.skip !== undefined) params.set("skip", query.skip.toString());
    if (query.take !== undefined) params.set("take", query.take.toString());

    const queryString = params.toString();
    const response = (
        await taskAxiosInstance.get<TaskOccurrenceListResponse>(
            `/task-occurrences${queryString ? `?${queryString}` : ""}`,
        )
    ).data;
    return response;
};

export const getTaskOccurrenceById = async (id: number): Promise<TaskOccurrence> => {
    const response = (await taskAxiosInstance.get<TaskOccurrence>(`/task-occurrences/${id}`)).data;
    return response;
};

export interface UpdateTaskOccurrenceInput {
    status?: TaskOccurrenceStatus;
}

export const updateTaskOccurrence = async (
    id: number,
    data: UpdateTaskOccurrenceInput,
): Promise<TaskOccurrence> => {
    const response = (
        await taskAxiosInstance.patch<TaskOccurrence>(`/task-occurrences/${id}`, data)
    ).data;
    return response;
};
